import React from 'react'
import clsx from 'clsx'
import { Box, Step, StepLabel, Stepper, Typography } from '@material-ui/core'

import useStyles from './styles'

const StepIcon = ({ icon, active, completed, classes }) => (
  <Box
    className={clsx(classes.stepIconRoot, {
      [classes.stepIconActive]: active,
      [classes.stepIconCompleted]: completed,
    })}
  >
    {icon}
  </Box>
)

const STEPS = [
  'Preview Curso',
  'Preview Certificado',
  'Gerenciar Alunos',
  'Configurações',
]

const ManageStepper = ({ activeStep }) => {
  const classes = useStyles()

  return (
    <Stepper
      activeStep={activeStep}
      alternativeLabel
      className={classes.stepper}
    >
      {STEPS.map((label, index) => (
        <Step key={label}>
          <StepLabel
            StepIconComponent={({ active, completed }) => (
              <StepIcon
                icon={index + 1}
                active={active}
                completed={completed}
                classes={classes}
              />
            )}
            classes={{
              active: classes.stepLabelActive,
              completed: classes.stepLabelCompleted,
            }}
          >
            <Typography variant="caption">{label}</Typography>
          </StepLabel>
        </Step>
      ))}
    </Stepper>
  )
}

export default ManageStepper
